/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type ContentSnippet from 'embercom/models/content-service/content-snippet';
import type App from 'embercom/app';
import { action } from '@ember/object';

interface Args {
  activeContent: ContentSnippet;
  defaultThemeColor: string;
}

export default class Editor extends Component<Args> {
  @service declare appService: AppService;

  get app(): App {
    return this.appService.app;
  }

  @action focusEditor(): void {
    let composer: HTMLElement | null = document.querySelector(
      '#fin-snippet-content-editor .ProseMirror',
    );
    if (composer && composer !== document.activeElement) {
      composer?.focus();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Snippet::Edit::Editor': typeof Editor;
    'knowledge-hub/content-editor/snippet/edit/editor': typeof Editor;
  }
}
